// 1. 引入
import axios from "axios";

// 2. 创建实例
const instance = axios.create({
    // 每次请求的协议、IP地址。  设置该配置后，每次请求路径都可以使用相对路径，例如"/admin/login"
    //  baseURL: "http://localhost:8900/",   //本地服务器
     baseURL: "http://192.168.10.79:8900/", //代理服务器
    // baseURL: "https://zhjgg.cn:8900", //代理服务器
    // 请求超时时间
    //timeout: 10000,
    // 每次请求携带cookie
    //withCredentials: true
})

instance.interceptors.response.use(resp=>{
    if(resp.headers.authorization === "WILL_EXPIRED"){
        axios.post("https://zhjgg.cn:8899/lightChat/login/updateAuthorization",null,{headers:{
                "authorization":sessionStorage.getItem("authorization")
            }}).then(respSecond=>{
            sessionStorage.setItem("authorization",respSecond.data.data)
        })
    }else if (resp.headers.authorization !== undefined){
        sessionStorage.setItem("authorization",resp.headers.authorization)
    }
    return resp;
},error=>{
    return {
        "data": {
            "code": 410,
            "msg": "连接失败",
            "data":"连接失败,请检查网络后重试"
        }
    }
})


// 3. 配置信息

// 4. 导出
export default instance
